import { request } from './client';

export function getFixtureSheetsByTournament(tournamentId) {
  return request(`/api/fixture-sheets/tournament/${tournamentId}`);
}
